import { Paragraph, convertMillimetersToTwip } from 'docx'
import { DraftConjointItem } from '../../data/gql-gen/questionnaire/graphql'
import { DraftQuestionnaireEntry } from '../../data/model/questionnaire'
import { CONJOINT_ATTRIBUTE_PREFIX, CONJOINT_LEVEL_PREFIX } from './model'

// "Attribute N: name" followed by its indented "Level N: value" lines.
// Numbering is 1-based; keys are rebuilt from ordinal position on import.
export const createEntryContentConjoint = (
  entry: DraftQuestionnaireEntry
): Paragraph[] => {
  const entryItem = entry.entryItem as DraftConjointItem
  const paragraphs: Paragraph[] = []

  entryItem.attributes.forEach((attribute, attributeIndex) => {
    paragraphs.push(
      new Paragraph(
        `${CONJOINT_ATTRIBUTE_PREFIX} ${attributeIndex + 1}: ${attribute.name}`
      )
    )
    attribute.options.forEach((option, optionIndex) => {
      paragraphs.push(
        new Paragraph({
          text: `${CONJOINT_LEVEL_PREFIX} ${optionIndex + 1}: ${option.value}`,
          indent: {
            start: convertMillimetersToTwip(6.3)
          }
        })
      )
    })
  })

  return paragraphs
}
